import React from 'react';
import { Button } from '@mui/material';
import { useButton } from './useButton';
import { BUTTON_MODE, BUTTON_VARIANT } from './interface';
import { radius } from 'common/theme';
import { FontFamily } from 'common/theme';

export { BUTTON_MODE, BUTTON_VARIANT };

export const ButtonHot = ({
  mode = 'contained',
  variant = 'primary',
  size = 'm',
  isActive = false,
  children,
  sx,
  disabled,
  startIcon,
  endIcon,
  fullWidth,
  testID,
  ...props
}) => {
  const { modeStyles, sizeStyles } = useButton(mode, variant, size, isActive);
  const { testId, ...restProps } = props;

  return (
    <Button
      testId={testID || testId}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      {...restProps}
      sx={{
        fontFamily: FontFamily.regular,
        borderRadius: `${radius.xxl}px`,
        textTransform: 'none',
        fontWeight: 400,
        ...sizeStyles,
        ...modeStyles,
        '&.Mui-disabled': {
          opacity: 0.5,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default ButtonHot;

